export class SessionFilter{
    public email: string;
}


// WEBPACK FOOTER //
// ./src/app/core/models/sessionFilter.model.ts